import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PasswordSection, SessionsSection } from "../components/account/AccountSections";
import { MfaSection } from "../components/account/MfaSection";

export default function Account() {
  const { user, ready, refresh, logout } = useAuth();

  if (ready && !user) return <Navigate to="/login" replace />;
  if (!user) return null;

  return (
    <div className="mx-auto max-w-2xl px-4 py-10 md:px-8">
      <div className="mb-6">
        <h1 className="font-head text-3xl font-extrabold tracking-tight">Mon compte</h1>
        <p className="mt-1 font-mono2 text-sm text-muted-foreground">{user.email} · {user.role === "admin" ? "Administrateur" : "Utilisateur"}</p>
      </div>
      <div className="space-y-6">
        <PasswordSection />
        <SessionsSection onLoggedOut={logout} />
        <MfaSection user={user} refresh={refresh} />
      </div>
    </div>
  );
}
